import TestimonialSlider from '../components/TestimonialSlider';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'my-order-form': {
        'product-id': string;
        'order-form-id': string;
        'base-url': string;
      };
    }
  }
}

export default function Checkout() {
  return (
    <div style={{ width: '100%', minHeight: '100vh' }}>
      <TestimonialSlider />
      <my-order-form
        product-id="432731"
        order-form-id="224710"
        base-url="https://www.checkout-ds24.com"
      />
    </div>
  );
}
